import { render } from "./FCSelect.vue?vue&type=template&id=74aafaed&scoped=true"
import script from "./FCSelect.vue?vue&type=script&lang=js"
export * from "./FCSelect.vue?vue&type=script&lang=js"

import "./FCSelect.vue?vue&type=style&index=0&id=74aafaed&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74aafaed"]])

export default __exports__